import type { CartLine } from '@/stores/cartStore';
import type { QuoteLineItem } from '@/types/Quote';

export interface QuoteTotals {
  subtotal: number;
  totalWeight: number;
  shipping: number;
  tax: number;
  total: number;
}

export interface QuoteMathConfig {
  /** Per-pound shipping rate in USD. */
  shippingRatePerLb: number;
  /** Minimum shipping cost in USD. */
  shippingMin: number;
  /** Tax rate as decimal (0.06 = 6%). */
  taxRate: number;
}

export const DEFAULT_QUOTE_CONFIG: QuoteMathConfig = {
  shippingRatePerLb: 1.85,
  shippingMin: 45,
  taxRate: 0.06,
};

type LineLike = Pick<CartLine | QuoteLineItem, 'qty' | 'unitPrice' | 'shippingWeight'>;

export function calculateTotals(
  lines: LineLike[],
  config: QuoteMathConfig = DEFAULT_QUOTE_CONFIG
): QuoteTotals {
  const subtotal = lines.reduce((acc, l) => acc + l.qty * l.unitPrice, 0);
  const totalWeight = lines.reduce((acc, l) => acc + l.qty * l.shippingWeight, 0);
  const shipping = Math.max(config.shippingMin, totalWeight * config.shippingRatePerLb);
  const tax = subtotal * config.taxRate;
  const total = subtotal + shipping + tax;
  return { subtotal, totalWeight, shipping, tax, total };
}
